import { GuardianExpoSection } from './GuardianExpoSubPageLayout'
import StackedImageCards from './StackedImageCards'

/**
 * 集章活動辦法區塊：兌換條件 QA 卡片 + 兌換時間說明 + 規則長圖列表
 * conditions: [{ chipLabel, descParts: [{ text, highlight? }] }]
 * redeemTimeParts: [{ text, highlight? }]
 * ruleImages: [{ id, src, alt }]
 */
export default function StampRallySection({
  titleBlack,
  titleRed,
  conditionsLabel,
  conditions,
  redeemTimeLabel,
  redeemTimeParts,
  eventTimeImageSrc,
  eventTimeImageAlt,
  fastPassLabel,
  ruleImages = [],
  onRuleImageClick,
  last = false,
}) {
  return (
    <GuardianExpoSection titleBlack={titleBlack} titleRed={titleRed} last={last}>
      <div className="flex flex-col self-stretch" style={{ gap: 24 }}>
        {/* 兌換條件 */}
        <div className="flex flex-col items-start self-stretch" style={{ gap: 8 }}>
          <p style={{ color: '#171717', fontFamily: 'Noto Sans TC', fontSize: 18, fontWeight: 400, lineHeight: '27px' }}>
            {conditionsLabel}
          </p>
          <div className="self-stretch overflow-hidden" style={{ borderRadius: 8, outline: '1px solid rgba(110,98,91,0.08)' }}>
            {conditions.map((condition, idx) => (
              <div
                key={idx}
                className="flex items-stretch self-stretch"
                style={{
                  background: 'rgba(255,255,255,0.3)',
                  borderBottom: idx < conditions.length - 1 ? '1px solid rgba(110,98,91,0.08)' : 'none',
                }}
              >
                <div className="flex items-center justify-center shrink-0" style={{ width: 70, padding: '0 10px', background: '#BC313D' }}>
                  <span className="text-center whitespace-pre-line" style={{ color: 'white', fontFamily: 'Noto Sans TC', fontSize: 15, fontWeight: 500, lineHeight: '22.5px' }}>
                    {condition.chipLabel}
                  </span>
                </div>
                <div className="flex-1 flex items-center" style={{ padding: '4px 10px' }}>
                  <p style={{ fontFamily: 'Noto Sans TC', fontSize: 18, fontWeight: 400, lineHeight: '27px' }}>
                    {condition.descParts.map((part, i) => (
                      <span key={i} style={{ color: part.highlight ? '#BC313D' : '#6E625B' }}>{part.text}</span>
                    ))}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 兌換時間 */}
        <div className="flex flex-col items-start self-stretch" style={{ gap: 8 }}>
          <p style={{ color: '#171717', fontFamily: 'Noto Sans TC', fontSize: 18, fontWeight: 400, lineHeight: '27px' }}>
            {redeemTimeLabel}
          </p>
          <p style={{ fontFamily: 'Noto Sans TC', fontSize: 18, lineHeight: '27px' }}>
            {redeemTimeParts.map((part, i) => (
              <span key={i} style={{ color: part.highlight ? '#BC313D' : '#6E625B', fontWeight: part.highlight ? 500 : 400 }}>{part.text}</span>
            ))}
          </p>
          {eventTimeImageSrc && (
            <img
              src={eventTimeImageSrc}
              alt={eventTimeImageAlt}
              className="self-stretch w-full h-auto"
            />
          )}
        </div>

        {/* FAST PASS 學習路線（規則說明長圖卡片堆疊，點擊放到最上層並開啟大圖） */}
        {ruleImages.length > 0 && (
          <div className="flex flex-col self-stretch" style={{ gap: 8 }}>
            {fastPassLabel && (
              <p style={{ color: '#171717', fontFamily: 'Noto Sans TC', fontSize: 18, fontWeight: 400, lineHeight: '27px', margin: '8px 0' }}>
                {fastPassLabel}
              </p>
            )}
            <StackedImageCards images={ruleImages} onCardClick={onRuleImageClick} />
          </div>
        )}
      </div>
    </GuardianExpoSection>
  )
}
